import * as React from "react";
import {
  Dialog,
  Box
} from "@material-ui/core";
import ScaledButton from "./ScaledButton";
import useZoomScale from "hooks/useZoomScale";
const defaultWidth = 400;
const defaultHeight = 300;
const defaultFontSize = 14;

export const AlertDialog = ({
  open,
  title,
  variant,
  description,
  onSubmit,
  onClose
}) => {
  const scale = Math.min(useZoomScale(), 1);
  const width = defaultWidth / scale;
  const maxHeight = defaultHeight / scale;
  const fontSize = defaultFontSize / scale;
  return (
    <Dialog open={open} maxWidth={width}>
      <Box p={3}>
        <div style={{ lineHeight: 1.3, overflow: 'auto', maxHeight, fontSize }} dangerouslySetInnerHTML={{__html: description}} />
        <Box mt={3} textAlign="center">
          {variant === "danger" ? (
            <>
              <ScaledButton color="primary" onClick={onSubmit}>
                Yes, I agree
              </ScaledButton>
              <ScaledButton color="primary" onClick={onClose} autoFocus>
                CANCEL
              </ScaledButton>
            </>
          )
          :
          (
            <ScaledButton color="primary" variant="contained" onClick={onSubmit}>
              OK
            </ScaledButton>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};
